<template>
  <b-col class="p-3 box-thumbnail">
    <div class="mb-4 h5">Thumbnail</div>
    <b-row>
      <b-col class="mb-3" style="max-width: max-content">
        <div
          :style="{
            'background-image': `url(${
              dataURL ? dataURL : require('@/assets/default-activity-cover.jpg')
            })`
          }"
          class="img-fluid rounded thumbnail img-content"
        ></div>
      </b-col>
      <b-col class="d-flex flex-column justify-content-around mb-3" style="max-width: max-content">
        <b-button
          variant="outline-primary"
          :disabled="disabled"
          @click="$refs.thumbnailS3Uploader.$refs.vueDropzone.$el.click()"
          >Upload Image</b-button
        >

        <b-button variant="link" :disabled="disabled" @click="resetThumbnail"
          >Reset to default</b-button
        >
      </b-col>
    </b-row>

    <div class="text-black-50">Supported File Types: .jpg, .jpeg, .png</div>
    <div class="text-black-50">Recommend Thumbnail Size: 160 x 100 pixel</div>

    <base-s3-uploader
      v-show="false"
      id="input-media"
      ref="thumbnailS3Uploader"
      v-model="$file"
      :reference-meta="{ ...referenceMeta, field: 'thumbnail' }"
      :dropzone-options="dropzoneThunnailOptions"
      :is-public="true"
      @onFilesAdded="onFilesAdded"
    >
    </base-s3-uploader>
  </b-col>
</template>

<script>
import Upload from '@/models/Upload';
import BaseS3Uploader from '@/components/base-components/BaseS3Uploader';

export default {
  components: {
    BaseS3Uploader
  },
  props: {
    referenceMeta: {
      type: Object,
      default: () => ({})
    },

    dropzoneThunnailOptions: {
      type: Object,
      default: () => ({
        acceptedFiles: '.jpeg, .jpg, .png',
        maxFiles: 1,
        maxfilesexceeded: function (file) {
          this.removeAllFiles(file);
          this.addFile(file);
        }
      })
    },

    disabled: {
      type: Boolean,
      default: false
    },

    file: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dataURL: ''
    };
  },

  computed: {
    $file: {
      get() {
        return this.file;
      },

      set(v) {
        this.$emit('update:file', v);
      }
    }
  },

  watch: {
    file: {
      immediate: true,
      async handler(f) {
        if (f && f.length) {
          const file = f[0];

          const { response } = await Upload.api().fetchPresignedUrl(file.id);

          this.dataURL = response.data.url;
        }
      }
    }
  },
  methods: {
    resetThumbnail() {
      if (this.file && this.file.length) {
        this.$refs.thumbnailS3Uploader.$refs.vueDropzone.removeAllFiles(this.file);
      } else {
        this.$refs.thumbnailS3Uploader.$refs.vueDropzone.removeAllFiles();
      }
      this.dataURL = '';
    },

    onFilesAdded(files) {
      const file = files[0];

      if (file.status === 'error') return;

      const reader = new FileReader();

      reader.addEventListener(
        'load',
        () => {
          // convert image file to base64 string
          this.dataURL = reader.result;
        },
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.box-thumbnail {
  border: 1px solid #d1d2db;
  border-radius: 10.4px;
}
.img-content {
  min-width: 160px;
  max-width: 160px;
  height: 100px;
  background-size: cover;
  background-position: top center;
}
</style>
